import './Infographic.scss';
import infographic from '../../_assets/_img/infographic.png';
import infographicMobile from '../../_assets/_img/infographic-mobile.png';

const Infographic = () => {
  return (
    <div className="infographic-container">
      <img src={infographic} className="mobile-hide"/>
      <img src={infographicMobile} className="mobile-show"/>
    </div>

  )
}

export default Infographic;